/**
 * Kazakh for the Astryx strings this app actually shows (form fields, dialogs,
 * pickers). Astryx ships no Kazakh catalogue; everything else falls back to Russian.
 */
export const astryxKk: Record<string, string> = {
  "@astryx.field.optional": "Міндетті емес",
  "@astryx.field.required": "Міндетті",
  "@astryx.step.optional": "Міндетті емес",
  "@astryx.fileInput.required": "Міндетті",
  "@astryx.dialog.close": "Жабу",
  "@astryx.banner.dismiss": "Жабу",
  "@astryx.popover.close": "Қалқымалы терезені жабу",
  "@astryx.toast.dismiss": "Хабарландыруды жабу",
  "@astryx.toast.viewport": "Хабарландырулар",
  "@astryx.alertDialog.cancel": "Бас тарту",
  "@astryx.spinner.loading": "Жүктелуде",
  "@astryx.commandPalette.loading": "Жүктелуде",
  "@astryx.calendar.previousMonth": "Алдыңғы ай",
  "@astryx.calendar.nextMonth": "Келесі ай",
  "@astryx.dateInput.placeholder": "Күнді таңдаңыз",
  "@astryx.dateInput.dialogLabel": "Күнді таңдау",
  "@astryx.dateInput.openCalendar": "Күнтізбені ашу",
  "@astryx.dateInput.closeCalendar": "Күнтізбені жабу",
  "@astryx.dateInput.toggleCalendarClose": "Күнтізбені жабу",
  "@astryx.dateInput.clear": "{label} тазалау",
  "@astryx.dateInput.invalidDate": "Күн дұрыс емес",
  "@astryx.dateInput.resetPicking": "Қалпына келтіру",
  "@astryx.dateInput.savePicking": "Сақтау",
  "@astryx.dateInput.doneChoosingMonth": "Дайын",
  "@astryx.dateInput.monthWheel": "Ай",
  "@astryx.dateInput.yearWheel": "Жыл",
  "@astryx.timeInput.placeholder": "Уақытты таңдаңыз",
  "@astryx.timeInput.invalidTime": "Уақыт дұрыс емес",
  "@astryx.timeInput.openPicker": "{label} ашу",
  "@astryx.timeInput.clearLabel": "{label} тазалау",
  "@astryx.dateTimeInput.hourWheel": "Сағат",
  "@astryx.dateTimeInput.minuteWheel": "Минут",
  "@astryx.dateTimeInput.timeHint24h": "мысалы, 14:30",
  "@astryx.textInput.clearLabel": "{label} тазалау",
  "@astryx.numberInput.clearLabel": "{label} тазалау",
  "@astryx.numberInput.decrementLabel": "{label} азайту",
  "@astryx.numberInput.incrementLabel": "{label} көбейту",
  "@astryx.selector.clearLabel": "{label} тазалау",
  "@astryx.selector.searchPlaceholder": "Іздеу…",
  "@astryx.selector.searchOptions": "Іздеу параметрлері",
  "@astryx.selector.empty": "Нұсқалар жоқ",
  "@astryx.fileInput.clearLabel": "{label} тазалау",
  "@astryx.fileInput.dropHint": "Файлдарды осында сүйреңіз",
  "@astryx.fileInput.placeholder": "Файлды таңдаңыз",
  "@astryx.fileInput.placeholderMultiple": "Файлдарды таңдаңыз",
  "@astryx.fileInput.fileSelected": "1 файл таңдалды: {fileName}",
  "@astryx.fileInput.errorInvalidType": "«{fileName}» файлының түріне қолдау көрсетілмейді",
  "@astryx.fileInput.errorMaxSize": "«{fileName}» файлының өлшемі {maxSize} шегінен асады",
  "@astryx.chat.composer.placeholder": "Хабарлама жазыңыз…",
  "@astryx.chat.composerInput.label": "Хабарлама енгізу өрісі",
  "@astryx.chat.status.sending": "Жіберілуде",
  "@astryx.chat.status.sent": "Жіберілді",
  "@astryx.chat.status.failed": "Қате",
  "@astryx.dropdownMenu.back": "Артқа",
  "@astryx.lightbox.close": "Жабу",
  "@astryx.lightbox.previous": "Артқа",
  "@astryx.lightbox.next": "Әрі қарай",
};
